import React, { useCallback, useState } from "react";
import styled from "@emotion/styled";
import { Toggle } from "@mediamath/design-system-eng";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import useLegacyPlatformView from "core/app/hooks/useLegacyPlatformView";
import appMessages from "core/app/intl/AppMessages";
import { StMenuItem } from "core/app/presenter/sideNav/SideNavMenuItem";
import ThemeToggle from "core/app/presenter/ThemeToggle";
import { Colors } from "design-system";

const StToggleBtn = styled(StMenuItem)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 10px;
  margin-left: -3px;
  .ui.checkbox,
  .ui.toggle.checkbox input.hidden + label {
    color: ${Colors.White} !important;
  }
  .ui.toggle.checkbox label:before {
    height: 19px !important;
  }
  &:hover {
    background: none;
    border-left-color: transparent;
  }
`;

const refreshPage = () => window.location.reload();

const SideNavToggles = ({ showLegacyPlatformView, isDarkMode }) => {
  const { isLegacyPlatform, setIsLegacyPlatform } = useLegacyPlatformView();
  const { formatMessage } = useIntl();
  const [toggleValue, setToggleValue] = useState(isLegacyPlatform);

  const handleChange = useCallback(() => {
    const value = !toggleValue;
    setIsLegacyPlatform(value);
    setToggleValue(value);
    setTimeout(() => refreshPage(), 200);
  }, [toggleValue, setIsLegacyPlatform]);

  return (
    <div>
      {showLegacyPlatformView && (
        <StToggleBtn>
          <Toggle
            checked={toggleValue}
            label={formatMessage(appMessages.legacyPlatform)}
            name="legacy_platform"
            onChange={handleChange}
          />
        </StToggleBtn>
      )}
      {isDarkMode && (
        <StToggleBtn>
          <ThemeToggle />
          <span>
            <sup>
              &nbsp;
              {formatMessage(appMessages.beta)}
            </sup>
          </span>
        </StToggleBtn>
      )}
    </div>
  );
};

SideNavToggles.propTypes = {
  showLegacyPlatformView: PropTypes.bool,
  isDarkMode: PropTypes.bool,
};

SideNavToggles.defaultProps = {
  showLegacyPlatformView: false,
  isDarkMode: false,
};

export default SideNavToggles;
